import { Component, OnInit, OnDestroy } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { getLearnMoreLinks } from '../data/learnmore';
import { LoginGuardService } from '../../api/login-guard.service';
import { AuthService } from '../../api/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'proctor-landing',
  templateUrl: './proctor-landing.component.html',
  styleUrls: ['./proctor-landing.component.scss']
})
export class ProctorLandingComponent implements OnInit, OnDestroy {

  breadcrumb:IBreadcrumbRoute[];
  learnMoreLinks = [];
  subs:Subscription[] = [];

  constructor(
    public lang:LangService,
    private auth: AuthService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
    ];
    this.learnMoreLinks = getLearnMoreLinks(
      this.breadcrumbsService.TESTADMIN_LEARNMORE().route+'/',
      this.breadcrumbsService.learnMoreSection.TESTADMIN,
    );
    // this.subs = this.subs.concat([
    //   this.auth.user().subscribe( )
    // ])
  }

  ngOnDestroy(){
    this.subs.forEach(sub => sub.unsubscribe() );
  }

  getAsyncUser(){
    return this.auth.user();
  }

}
